import { Skeleton } from '@mui/material';
import styled from 'styled-components';
import UserInitials from '@/trio-ui/UserInitials';
import type { PTORequestItemLayout } from '../PTORequestItem/PTORequestItem.component';

type ItemTextPros = {
  lighten?: boolean;
};

export const Content = styled.div<{ $layout: PTORequestItemLayout }>`
  display: flex;
  flex-direction: ${({ $layout }) => ($layout === 'wide' ? 'row' : 'column')};
  width: 100%;

  box-shadow: inset 0px 4px 6px rgba(0, 0, 0, 0.07);
  background-color: ${(props) => props.theme.colors['neutral-20']};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-wrap: wrap;
  }
`;

export const LeftPanel = styled.div<{ $layout: PTORequestItemLayout }>`
  padding: 16px;
  padding-inline-start: ${({ $layout }) => ($layout === 'wide' ? 64 : 16)}px;
  height: 100%;
  width: ${({ $layout }) => ($layout === 'wide' ? 65 : 100)}%;
  padding-inline-end: 16px;
  border-style: solid;
  border-color: ${(props) => props.theme.colors['neutral-40']};
  border-right-width: ${({ $layout }) => ($layout === 'wide' ? 1 : 0)}px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
    padding-inline-start: 16px;
    border-right: 0;
  }
`;

export const RightPanel = styled.div<{ $layout: PTORequestItemLayout }>`
  padding-top: ${({ $layout }) => ($layout === 'wide' ? 16 : 0)}px;
  padding-right: 16px;
  padding-bottom: 16px;
  padding-left: 16px;
  height: 100%;
  width: ${({ $layout }) => ($layout === 'wide' ? 35 : 100)}%;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }
`;

export const Title = styled.p`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-90']};
`;

export const CardTable = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  padding: 12px;
  gap: 8px;
  background: ${(props) => props.theme.colors['neutral-20']};
  border: 1px solid ${(props) => props.theme.colors['neutral-40']};
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.07);
  border-radius: 4px;
  &:not(:last-of-type) {
    margin-block-end: 16px;
  }
`;

export const CardTableItem = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 4px;

  &:not(:last-of-type) {
    padding-block-end: 8px;
    border-bottom: 1px solid ${(props) => props.theme.colors['neutral-40']};
  }
`;

export const TeamMemberUsercontainer = styled.div`
  display: flex;
  flex: 1 1 0;
  gap: 8px;
`;

export const TeamMemberName = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['primary-60']};
`;

export const ItemText = styled.span<ItemTextPros>`
  flex: 1 1 0px;
  font-size: 14px;
  line-height: 150%;
  color: ${(props) =>
    props.lighten ? props.theme.colors['neutral-70'] : props.theme.colors['neutral-90']};
`;

export const ItemBoldText = styled(ItemText)`
  font-weight: 600;
`;

export const AddCommentText = styled.button`
  cursor: pointer;
  display: block;
  margin-right: auto;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['primary-60']};
`;

export const TeamMemberInitials = styled(UserInitials)`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-right: 0;
`;

export const TeamMemberNameEmptyState = styled(Skeleton)`
  width: 80px;
  height: 14px;
  margin-top: 4px;
  margin-bottom: 3px;
`;
